import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "../../../../../components";
import { errorAlert } from "../../../../../helpers/alerts";
import { getAllPINProductsService, getPINProductsService } from "services/admin/productService";
import { setCredPINProductService } from "services/admin/providerService";
import { setCurrentPINProduct, setPINProducts as setProviderPINProducts } from "redux/slices/admin/providerSlice";
import { Grid } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { setPINProducts } from "redux/slices/admin/productSlice";
import { filterDuplicates, sortArrayBy } from "helpers/util";

const CredPINProductScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    providerCredSelected,
    pinProducts: providerPINProducts,
  } = useSelector((store) => store.providers);
  const {
    pinProducts
  } = useSelector((state) => state.products);

  useEffect(() => {
    getAllPINProductsService()
      .then((data) => dispatch(setPINProducts(data)))
      .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async (row, state) => {
    setCredPINProductService(providerCredSelected.id, row.idSegment.id, row.id, !state).then((result) => {
      dispatch(setProviderPINProducts(result));
    }).catch(error => errorAlert(error))
  };

  const handlerEdit = (row) => {
    dispatch(setCurrentPINProduct(row));
    navigate('editar');
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate('..')} />
        </div>
        <div className="container-title">
          <div className="title">Productos</div>
          <div className="subtitle">{providerCredSelected.name_connector}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <TableData
        dataRows={sortArrayBy(pinProducts, a => a.name).map((item) => {
          const service = providerPINProducts?.find(({ idProduct }) => idProduct.id === item.id);
          return {
            ...item,
            service
          };
        })}
        dataTitle={["Logo", "Nombre", "SKU", "Estado"]}
        formatter={({ fd, name, service }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          service?.sku || filterDuplicates(service?.amounts, 'sku')?.map(a => a.sku).join(', ') || '-',
          { name: "state", type: "boolean", value: service?.state, disabled: !service?.sku },
        ]}
        onChecked={handlerCheck}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => {
              handlerEdit(data);
            },
          },
        ]}
      />
    </>
  );
};

export default CredPINProductScreen;
